import React from 'react';
// import ReactDOM from 'react-dom'
// import Blockies from 'react-blockies';

// import { Input, FilledInput } from '@material-ui/core';
import { Input } from '@material-ui/core';

// import { makeStyles } from '@material-ui/core/styles';

function Text() {
  this.addInput("", 0);
  this.addOutput("", "string");
  this.properties =  {blockieSize: 24,placeholder:"...",title:"Text",value:null}
  this.size = [300, 50];
}

Text.title = "Text";

Text.prototype.onConnectionsChange = function(args){
  console.log("onConnectionsChange",args)
}

Text.prototype.onExecute = function() {
  let input = this.getInputData(0)
  if (this.inputs[0] && typeof input !== "undefined" && this.properties.value !== input ) {
    this.properties.value = input;
  }
  this.setOutputData(0,this.properties.value);
};

Text.prototype.getTitle = function() {
  if (this.flags.collapsed && this.properties.value) {
    return this.properties.value
  }
  return this.properties.title;
};

Text.prototype.handle = function(e) {
    this.properties.value = e.target.value
    this.setOutputData(0,this.properties.value);
    this.onDrawBackground()
}

Text.prototype.onDrawBackground = function(ctx) {

  if (this.flags.collapsed) {
    /*this.render(
      <div>

      </div>
    )*/
    this.destroy()///SHOULD WE DESTROY THE ELEMENT FROM THE DOM OR
  }else{
    this.render(
      <div>
        <form className={"SOMECONTAINERCLASS"} noValidate autoComplete="off">
          <Input
            style={{width:"100%",height:32,color:"#dddddd",fontSize:this.properties.fontSize}}
            id={"react-input-"+this.id}
            label="Name"
            placeholder={this.properties.placeholder}
            value={this.properties.value}
            onChange={Text.prototype.handle.bind(this)}
            margin="normal"
            variant="outlined"
          />
        </form>
      </div>
    )
  }


};




export default Text
